import { useState, useContext, useEffect }   from 'react';
import { Link }                   from 'react-router-dom';
import { Form, Segment, Divider } from 'semantic-ui-react';
import { loadStripe }             from '@stripe/stripe-js';
import { api_url, stripe_key }    from '../../../config';
import jwt_decode                 from 'jwt-decode';
import styled                     from 'styled-components';
import useLocalStorage            from '../../../libs/useLocalStorage';
import Center                     from '../../../components/Auth/Center';
import HeaderName                 from '../../../components/Auth/HeaderName';
import CenterWidth                from '../../../components/Auth/CenterWidth';
import CenterMessage              from '../../../components/CenterMessage';
import ButtonStretch              from '../../../components/ButtonStretch';
import FlexBox                    from '../../../components/FlexBox';
import AppContext                 from '../../../context/HeaderContext';

const CustomFlexBox = styled(FlexBox)`
	justify-content: space-around;
`;

function Login({ history }) {
	const {
		updateOrganizationId,
		updateProjectId,
		clearLocalStorage,
	} = useContext(AppContext);
	const [ jwt_token, setJwtToken ]   = useLocalStorage(`jwt_token`);
	const [ , setUser ]                = useLocalStorage(`user`);
	const [ loading, setLoading ]      = useState(false);
	const [ login_data, setLoginData ] = useState({});
	const [ error, setError ]          = useState(false);
	const [ subdomain, setSubdomain ]  = useState(null);

	if(jwt_token) {
		window.location = `/`;
	}

	useEffect(() => {
		const host_parts = window.location.hostname.split(`.`);

		if(host_parts.length > 2) {
			setSubdomain(host_parts[0]);
		}
	}, []);

	function handleChange(e) {
		setLoginData({
			...login_data,
			[e.target.name] : e.target.value
		});
	}

	function handleSubmit() {
		setError(false);

		if(!login_data.email || !login_data.password) {
			setError(`Invalid email or password`);
		}

		setLoading(true);

		fetch(`${api_url}/authenticate`, {
			method : `POST`,
			body   : JSON.stringify(login_data),
			headers : {
				'Content-Type' : `application/json`
			}
		}).then(response => response.json()).then(async data => {
			if(data.error) {
				setError(data.error);
				setLoading(false);

				return;
			}

			// If the user's organization hasn't completed payment, redirect to Stripe checkout
			if(!data.jwt) {
				const checkout_session_id = data.checkout_session_id;
				const stripe              = await loadStripe(stripe_key);

				const { error } = await stripe.redirectToCheckout({
					sessionId : checkout_session_id,
				});

				if(error) {
					console.log(error);
					setError(error.message);
					setLoading(false);

					return;
				}

				return;
			}

			clearLocalStorage();
			const decoded = jwt_decode(data.jwt);

			console.log(decoded);
			setJwtToken(data.jwt);
			setUser(decoded.sub.user);

			updateOrganizationId(decoded.sub.user.organization_id || 2);
			updateProjectId(decoded.sub.user.project_id || 2);

			setLoading(false);
		});
	}

	return (
		<Center>
			<CenterWidth>
				<HeaderName />

				<Form>
					<Form.Field>
						<label>Email</label>
						<input placeholder="Email" name="email" onChange={handleChange}></input>
					</Form.Field>
					<Form.Field>
						<label>Password</label>
						<input type="password" placeholder="Password" name="password" onChange={handleChange}></input>
					</Form.Field>

					<ButtonStretch loading={loading} positive type="submit" onClick={handleSubmit}>Log In</ButtonStretch>
				</Form>

				{error &&
					<CenterMessage negative>
						<p>{error}</p>
					</CenterMessage>
				}

				<Divider />

				<Segment>
					<CustomFlexBox>
						{subdomain === `app` && (
							<div>
								<Link to="/signup">Sign Up</Link>
							</div>
						)}

						<div>
							<Link to="/request-password-reset">Forgot Password</Link>
						</div>
					</CustomFlexBox>
				</Segment>

				{subdomain === `app` && (
					<Segment>
						<CustomFlexBox>
							<div>
								Having trouble? Contact us on X <a href="https://twitter.com/willbrock">@willbrock</a>
							</div>
						</CustomFlexBox>
					</Segment>
				)}
			</CenterWidth>
		</Center>
	);
}

export default Login;
